import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-admin-roles-list',
  templateUrl: './admin-roles-list.component.html',
  styleUrls: ['./admin-roles-list.component.css']
})
export class AdminRolesListComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  rolesList: any;
  roleEnable: any;
  totalRecords: number;
  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals) {
    this.g.page = " Roles List";
    this.getRolesList();
  }

  ngOnInit(): void {
  }


  getRolesList() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Role Code'
      },
      ajax: (dataTablesParameters: any, callback) => {

        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/getOrganizationRoleList';
        // http://localhost:8080/api/getOrganizationRoleList?organizationId=1&page=0&searchString=role&size=1&status=ACTIVE
        let query: any = {
          status: 'ALL',
          organizationId: 1,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.rolesList = resp.rolesList;
            this.totalRecords = resp.noOfRecords;
            this.g.loaderDisplay = "";
            this.rolesList.forEach((r) => {
              if (r.status === 'ACTIVE') {
                r.roleEnable = true;
              } else {
                r.roleEnable = false;
              }
            });
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    }
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  changeStatus(r) {
    let api = "";
    this.g.loaderDisplay = "display";
    if (r.roleEnable) {
      api = 'api/activateRole';
      r.status = "ACTIVE";
    }
    else {
      api = 'api/deActivateRole';
      r.status = "IN_ACTIVE";
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + api, {
      "id": r.roleId,
      "status": r.status
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success('Roles', 'Status Updated Successfully');
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


}
